import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { formatTime } from "../../lib/format";

const hrs = (m) => ((m || 0) / 60).toFixed(1);

// One person per row: name, branch, check-in, check-out, late, worked, overtime.
export const TodayTable = ({ list }) => {
  const { t } = useTranslation();

  if (list.length === 0)
    return (
      <NeuCard data-testid="today-empty">
        <p className="text-sm text-muted-foreground">{t("app.none")}</p>
      </NeuCard>
    );

  return (
    <NeuCard data-testid="today-table">
      <ul className="grid gap-2">
        {list.map((r, i) => (
          <li
            key={`${r.user_id}-${i}`}
            data-testid={`today-row-${r.user_id}`}
            className="grid gap-2 rounded-2xl p-4 shadow-neu-in sm:grid-cols-[1.4fr_repeat(5,minmax(0,1fr))] sm:items-center"
          >
            <div className="min-w-0">
              <p className="truncate text-sm font-bold">{r.employee_name}</p>
              <p className="truncate text-[11px] text-muted-foreground">{r.branch_name || "—"}</p>
            </div>
            <Cell label={t("check.checkedInAt")} value={r.check_in_at ? formatTime(r.check_in_at) : "—"} />
            <Cell
              label={t("check.checkedOutAt")}
              value={r.check_out_at ? formatTime(r.check_out_at) : "—"}
              accent={Boolean(r.check_out_at)}
            />
            <Cell label={t("check.late")} value={r.late_minutes ? `${r.late_minutes}'` : "—"} danger={r.late_minutes > 0} />
            <Cell label={t("dashboard.totalHours")} value={r.worked_minutes ? hrs(r.worked_minutes) : "—"} />
            <Cell label={t("dashboard.overtime")} value={r.overtime_minutes ? hrs(r.overtime_minutes) : "—"} />
          </li>
        ))}
      </ul>
    </NeuCard>
  );
};

const Cell = ({ label, value, accent, danger }) => (
  <div>
    <p className="text-[10px] text-muted-foreground">{label}</p>
    <p
      className={`font-mono text-sm font-bold ${danger ? "text-destructive" : accent ? "text-primary" : ""}`}
      dir="ltr"
    >
      {value}
    </p>
  </div>
);
